import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationEmailNotConfirmedError extends ExpectedError {
  static override _class = 'RegistrationEmailNotConfirmedError';

  public constructor() {
    super('RegistrationEmailNotConfirmedError', { translationKey: 'REGISTRATION_EMAIL_NOT_CONFIRMED_ERROR' });
  }
}
